var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"5 3 19 12 5 21 5 3"}));
}

Play.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-play"};

module.exports = Play;

Play.default = Play;
